import { jsx as _jsx } from "react/jsx-runtime";
import { TabPanels as ChakraTabPanels } from '@chakra-ui/react';
/**
 * Used to manage the rendering of multiple tab panels. It uses cloneElement to hide/show tab panels.
 * It renders a div by default.
 *
 * @see Docs https://bit.cloud/caspeco/casper-ui-library/components/tabs
 */
export function TabPanels({ children, ...props }) {
    return _jsx(ChakraTabPanels, { ...props, children: children });
}
//# sourceMappingURL=tabPanels.js.map